import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';

const VideoModal = ({ isOpen, onClose, videoUrl }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} titleName="Video" contentWidth="50%">
      <div className="resource-view d-flex justify-content-center">
        <video controls className='w-100 h-auto'>
          <source src={videoUrl} type="video/mp4" />
        </video>
      </div>
    </Modal>
  );
};
    
VideoModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  videoUrl: PropTypes.string
};

export default VideoModal;